import { LoginPayload, AuthResponse } from '@/types/auth';
import { api } from './axios';
import { useAuthStore } from '@/store/auth.store';
import { useRouter } from 'vue-router';
import { useCompanyStore } from '@/store/company.store';

export const AuthService = {
  async login(payload: LoginPayload): Promise<AuthResponse> {
    try {
      const response = await api.post<AuthResponse>('/api/auth/login', payload);
      const authStore = useAuthStore();
      
      if (response.data.data?.token) {
        const { token, user, retail_auth } = response.data.data;
        localStorage.setItem('token', token);
        localStorage.setItem('retail_token', retail_auth.token);
        localStorage.setItem('user', JSON.stringify(user));
        authStore.setToken(token);
        authStore.setRetailToken(retail_auth.token);
        authStore.setUser(user);
      }
      return response.data;
    } catch (error) {
      console.error('Login error:', error);
      throw error;
    }
  },
  
  async logout(): Promise<void> {
    try {
      await api.post('/api/auth/logout');
    } finally {
      const authStore = useAuthStore();
      const companyStore = useCompanyStore();
      localStorage.removeItem('token');
      localStorage.removeItem('user');
      authStore.clearAuth();
      companyStore.clearSelectedCompany();
    }
  },

  getCurrentUser() {
    const userStr = localStorage.getItem('user');
    if (userStr) return JSON.parse(userStr);
    return null;
  },

  getToken() {
    return localStorage.getItem('token');
  }
};

export const handleLogout = async (): Promise<void> => {
  try {
    await AuthService.logout();
    const router = useRouter();
    router.push('/login');
  } catch (error) {
    console.error('Logout failed:', error);
  }
};